import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsermanagementComponent } from './usermanagement/usermanagement.component';
import { AngularMaterialModule } from '../angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedControlsModule } from '../shared-controls/shared-controls.module';
import { AclDataModule } from '../acl-data/acl-data.module';
import { PopupConfirmationComponent } from '../modal/popup-confirmation/popup-confirmation.component';
import { ModalModule } from '../modal/modal.module';
import { ManageUserAccessComponent } from './manage-user-access/manage-user-access.component';
import { AccessTypePopupComponent } from './access-type-popup/access-type-popup.component';

@NgModule({
    declarations: [UsermanagementComponent, ManageUserAccessComponent, AccessTypePopupComponent],
    imports: [
        CommonModule,
        FormsModule,
        SharedControlsModule,
        AclDataModule,
        AngularMaterialModule,
        
        
    ],
    entryComponents: [UsermanagementComponent],
})
export class UserManagementModule {}
